const LONDON = 'Europe/London'

export function gbp(pence: number | null | undefined): string {
  if (pence === null || pence === undefined) return '—'
  const pounds = pence / 100
  const text = pounds.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: pounds % 1 === 0 ? 0 : 2,
  })
  return text
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: '2-digit', timeZone: LONDON,
  })
}

export function longDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: LONDON,
  })
}

export function dayAndTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    weekday: 'short', day: 'numeric', month: 'short',
    hour: '2-digit', minute: '2-digit', timeZone: LONDON,
  })
}

export function timeOnly(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-GB', {
    hour: '2-digit', minute: '2-digit', timeZone: LONDON,
  })
}

/** "3h" / "5d" — how long something has been waiting. */
export function waited(hours: number | null): string {
  if (hours === null) return '—'
  if (hours < 1) return 'now'
  if (hours > 48) return `${Math.round(hours / 24)}d`
  return `${Math.round(hours)}h`
}

export function titleise(value: string): string {
  return value.replace(/_/g, ' ')
}
